import { render, staticRenderFns } from "./TheCard.vue?vue&type=template&id=4fa674d8&scoped=true"
import script from "./TheCard.vue?vue&type=script&lang=js"
export * from "./TheCard.vue?vue&type=script&lang=js"
import style0 from "./TheCard.vue?vue&type=style&index=0&id=4fa674d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa674d8",
  null
  
)

export default component.exports